
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    RadioButton,
    ProgressBar,
} from "@gpstrackit/react-controls";

import { Chip } from "@mui/material";

import { getCerebrumXOEMs } from 'Core/data/Helpers';

//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './addCerebrumXOEM.scss';

//Actions
import {
    addOemRequest,
    clearRedux,
} from 'Redux/actions';
import { set } from "lodash";

const AddCerebrumXOEM = (props) => {
    const { tableRef, updateOEMs } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    //Redux States
    const { loading, openModal, result, companyIntegrationId, companyOems, fleetId } = useSelector(state => state.addCerebrumXOEMRedux)

    //Local States
    const [oem, setOem] = useState(null);
    const [fanId, setFanId] = useState(null);


    const closeModal = () => {

        dispatch(clearRedux("ADD_OEM"));
    }


    const applyChanges = () => {

        let payload = {
            oem,
            companyIntegrationId,
            fanId,
            fleetId
        }

        dispatch(addOemRequest(payload))
    }

    useEffect(() => {

        if (result) {
            dispatch(clearRedux("ADD_OEM", { result: null }))
            if (!result?.error) {
                NotificationManager.success(
                    messages['add_oem_success_message'],
                    messages['add_oem_title'],
                    3000
                );

                closeModal();

                tableRef && tableRef?.current?.getData();
                updateOEMs && updateOEMs();
            } else {
                NotificationManager.error(
                    messages['add_oem_error_message'],
                    messages['add_oem_title'],
                    3000
                );

            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['add_oem_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: '78vh' }}>
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid item xs={12} style={{ marginTop: 10 }}>
                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['add_oem_type']}</label>
                        </Grid>

                        <Grid item xs={12} style={{ marginTop: 10 }}>
                            {
                                getCerebrumXOEMs()?.map((item, index) => {
                                    if (!companyOems.find(o => o.name === item))
                                        return (
                                            <Grid key={index} style={{ marginTop: 10 }}>
                                                <Chip
                                                    onClick={(() => {
                                                        setOem(item);
                                                    })}
                                                    style={{
                                                        marginRight: 5,
                                                        cursor: 'pointer',
                                                        backgroundColor: oem === item ? '#1D2734' : "#00000014",
                                                        color: oem === item ? 'white' : "#000000de"
                                                    }}
                                                    label={item}
                                                />
                                            </Grid>
                                        )
                                })
                            }
                        </Grid>
                        {
                            oem === "GM" &&
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <Input
                                    type="text"
                                    label={messages['add_oem_fanid']}
                                    placeholder={messages['add_oem_fanid']}
                                    autoComplete="new-password"
                                    value={fanId}
                                    onChange={(value) => setFanId(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    maxLength={20}
                                    minLength={3}
                                    minLengthMessage={`${messages['add_oem_fanid_min']} 3`}
                                    maxLengthMessage={`${messages['add_oem_fanid_max']} 20`}
                                />
                            </Grid>
                        }
                    </Grid>
                </div>



            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    disabled={!oem}
                    onClick={() => {
                        applyChanges()
                    }}
                >
                    {messages['add_oem_save_oem']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default AddCerebrumXOEM;